import { create } from 'zustand';

/**
 * `null` until whoami brings the account's choice, and again after sign-out. PostHog's own
 * record decides meanwhile, and anyone who hasn't opted in is counted anonymously, without
 * cookies. Consent to the cookie policy is given at signup, so a user's analytics is on until
 * they turn it off in Settings.
 */
export type AnalyticsConsent = 'granted' | 'denied' | null;

interface ConsentState {
  analytics: AnalyticsConsent;
  setAnalytics: (choice: 'granted' | 'denied') => void;
  /** Forget the choice, on sign-out. */
  clearAnalytics: () => void;
}

/**
 * The signed-in user's analytics choice. It is saved on the account, and whoami hands it back
 * on sign-in. Held in memory only: a browser keeps no choice of its own, so whoever signs in
 * next gets theirs rather than the last user's.
 */
export const useConsentStore = create<ConsentState>((set) => ({
  analytics: null,
  setAnalytics: (choice) => set({ analytics: choice }),
  clearAnalytics: () => set({ analytics: null }),
}));

/** Whether analytics may run: on unless the user has turned it off. */
export function analyticsAllowed(consent: AnalyticsConsent = useConsentStore.getState().analytics) {
  return consent !== 'denied';
}
